module.exports = __webpack_public_path__ + "static/031-91208dc20d1b411ea2dc20c0b78e6758.png";